import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
var __default__ = {
  name: "GroupsIndex",
  data: function data() {
    return {
      showParticipantGroup: true,
      showStudentGroup: true,
      studentGroups: [],
      participantGroups: [],
      classroomGroups: [],
      filteredStudentGroups: [],
      filteredParticipantGroups: [],
      filteredClassroomGroups: [],
      filter: {
        keyword: "",
        classroom: false
      }
    };
  },
  computed: _objectSpread({}, mapState(["studentAddress"])),
  mounted: function mounted() {
    var classroomGroups = this.groups.filter(function (v) {
      return v.type === "student" && v.class_id;
    });
    var groupsByClassroom = [];
    this.classrooms.forEach(function (v) {
      if (classroomGroups.filter(function (g) {
        return g.class_id === v.id;
      }).length > 0) {
        groupsByClassroom.push(Object.assign({}, v, {
          group: classroomGroups.filter(function (g) {
            return g.class_id === v.id;
          })
        }));
      }
    });
    this.filteredClassroomGroups = this.classroomGroups = groupsByClassroom;
    this.filteredStudentGroups = this.studentGroups = this.groups.filter(function (v) {
      return v.type === "student" && !v.class_id;
    });
    this.filteredParticipantGroups = this.participantGroups = this.groups.filter(function (v) {
      return v.type === "participant";
    });
    this.filteredStudentGroups = this.filteredStudentGroups.sort(function (a, b) {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
    this.filteredParticipantGroups = this.filteredParticipantGroups.sort(function (a, b) {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
  },
  methods: {
    filterList: function filterList() {
      var _this = this;

      if (this.showStudentGroup) {
        var filteredClassroomGroups = [];
        this.classroomGroups.forEach(function (v) {
          if (_this.filter.keyword) {
            var keywordMatched = v.group.find(function (v2) {
              return v2.name.indexOf(_this.filter.keyword) > -1;
            });

            if (keywordMatched) {
              var copy = Object.assign({}, v);
              copy.group = copy.group.filter(function (v2) {
                return v2.name.indexOf(_this.filter.keyword) > -1;
              });

              if (_this.filter.classroom) {
                if (_this.filter.classroom === v.id) {
                  filteredClassroomGroups.push(copy);
                }
              } else {
                filteredClassroomGroups.push(copy);
              }
            }
          } else {
            if (_this.filter.classroom) {
              if (_this.filter.classroom === v.id) {
                filteredClassroomGroups.push(v);
              }
            } else {
              filteredClassroomGroups.push(v);
            }
          }
        });
        this.filteredClassroomGroups = filteredClassroomGroups;

        if (this.filter.classroom) {
          this.filteredStudentGroups = [];
        } else {
          this.filteredStudentGroups = this.studentGroups.filter(function (v) {
            return v.name.indexOf(_this.filter.keyword) > -1;
          });
        }
      } else {
        this.filteredClassroomGroups = [];
        this.filteredStudentGroups = [];
      }

      if (this.showParticipantGroup) {
        if (this.filter.classroom) {
          this.filteredParticipantGroups = [];
        } else {
          this.filteredParticipantGroups = this.participantGroups.filter(function (v) {
            return v.name.indexOf(_this.filter.keyword) > -1;
          });
        }
      } else {
        this.filteredParticipantGroups = [];
      }
    }
  }
};
import { mapState } from "vuex";
import RowItem from "../RowItem"; // store

import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
import { useGroupStore } from "@/stores/group";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _storeToRefs = storeToRefs(useGroupStore()),
        groups = _storeToRefs.groups;

    var _storeToRefs2 = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs2.classrooms;

    expose({
      groups: groups,
      classrooms: classrooms
    });
    return {
      __sfc: true,
      groups: groups,
      classrooms: classrooms,
      RowItem: RowItem
    };
  }
});